import {
  BATCH_PLANNING_MAX_ROWS,
  DEMO_BATCH_PLANNING_LIMIT_MESSAGE,
  DEMO_BATCH_PLANNING_MAX_PROPERTIES,
  batchPlanningRowLimit,
  demoBatchPlanningPropertyLimit,
  uniquePropertyCountForWorkOrders,
  uniquePropertyIdsForWorkOrders,
  validateBatchPlanningRowLimit,
  validateDemoBatchPlanningPropertyLimit,
  type DemoBatchPlanningLimitContext,
} from "../../../../../../../../../../../../_shared/_logic/demo-batch-planning-limit"

export {
  BATCH_PLANNING_MAX_ROWS,
  DEMO_BATCH_PLANNING_LIMIT_MESSAGE,
  DEMO_BATCH_PLANNING_MAX_PROPERTIES,
  batchPlanningRowLimit,
  demoBatchPlanningPropertyLimit,
  uniquePropertyCountForWorkOrders,
  uniquePropertyIdsForWorkOrders,
  validateBatchPlanningRowLimit,
  validateDemoBatchPlanningPropertyLimit,
  type DemoBatchPlanningLimitContext,
}

export const buildBatchWorkOrderRowId = (propertyId: string, propertyUnitId?: string | null) =>
  `${propertyId}:${propertyUnitId || "no-unit"}`

export const normalizeSelectedBatchUnitIds = (
  property: Property,
  selectedIds?: string[] | null,
) => {
  const unitIds = (property.units ?? []).map((unit) => `${unit.id}`)
  const validIds = new Set(unitIds)

  if (selectedIds !== undefined && selectedIds !== null) {
    const selected = Array.from(
      new Set(selectedIds.map((id) => `${id}`).filter((id) => validIds.has(id))),
    )

    return unitIds.filter((id) => selected.includes(id))
  }

  if (unitIds.length === 1) {
    return [unitIds[0]]
  }

  return []
}

export const resolveBatchPropertyUnitIds = (
  property: Property,
  selectedByPropertyId: Record<string, string[]>,
) => normalizeSelectedBatchUnitIds(property, selectedByPropertyId[property.id])
